import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Maintenance from "./Maintenance";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import i18n from "i18next";
import "./i18n";
import { Helmet } from "react-helmet"

import { I18nextProvider } from "react-i18next";

import "./styles/index.css";
import "./styles/markdown.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();
const REACT_APP_CONSENT_MANAGEMENT_PLATFORM_SRC = process.env.REACT_APP_CONSENT_MANAGEMENT_PLATFORM_SRC;
if (process.env.REACT_APP_MAINTENANCE === "true") {
  root.render(
    <I18nextProvider i18n={i18n}>
      <Maintenance />
    </I18nextProvider>
  );
} else {
  console.log(process.env)
  root.render(
    <I18nextProvider i18n={i18n}>
      <React.StrictMode>
        <Helmet>
          {REACT_APP_CONSENT_MANAGEMENT_PLATFORM_SRC ? <script type="text/javascript" src={REACT_APP_CONSENT_MANAGEMENT_PLATFORM_SRC}></script> : null}
        </Helmet>
        <QueryClientProvider client={queryClient}>
          <React.Suspense fallback="Loading...">
            <App />
          </React.Suspense>
        </QueryClientProvider>
      </React.StrictMode>
    </I18nextProvider>
  );
}


reportWebVitals();
